import Decimal from 'decimal.js';
import { CurrencySymbol } from '@libs/types';
import { RegexValidators } from '@libs/validations';
import { getDecimalValue } from './decimalWrapper';
export const getEstimatedAmount = (val, defaultPrecision = 12, shouldRound = true) => {
    if (val === undefined || val === null)
        return '--';
    const value = getDecimalValue(val || 0);
    let precision = defaultPrecision;
    if (value.cmp(1) === 1) {
        precision = 2;
    }
    else if (value.cmp(0.1) === 1) {
        precision = 4;
    }
    return formatNumber(val, shouldRound ? precision : undefined);
};
export const formatAmountWithSymbol = ({ amount, symbol = CurrencySymbol.USDT, shouldLoad = true, shouldHaveSpace = true, reverse = false, shouldRound = true, roundingPrecision, }) => {
    if (amount === undefined || amount === null) {
        if (shouldLoad) {
            return '--';
        }
        return undefined;
    }
    const space = shouldHaveSpace ? ' ' : '';
    if (reverse) {
        return (getEstimatedAmount(amount || 0, roundingPrecision, shouldRound) +
            space +
            symbol);
    }
    return (symbol +
        space +
        getEstimatedAmount(amount || 0, roundingPrecision, shouldRound));
};
export const formatNumber = (val, precision = 7) => {
    if (val === undefined)
        return '--';
    const value = getDecimalValue(val || 0).toDecimalPlaces(precision, Decimal.ROUND_DOWN);
    return value.toNumber().toLocaleString('en-US', {
        maximumFractionDigits: precision,
    });
};
export const sum = (firstValue = 0, secondValue = 0) => {
    return getDecimalValue(firstValue).plus(secondValue).toNumber();
};
export const formatCryptoAmount = (amount, price, assetPrecision) => {
    let precision = assetPrecision;
    const amountDecimal = getDecimalValue(amount);
    const priceDecimal = getDecimalValue(price);
    if (amount > 1) {
        const division = amountDecimal.div(priceDecimal);
        if (division.toNumber() > 1) {
            precision = 2;
        }
        else {
            const stringAfterDot = division.toString().replace('0.', '');
            const match = stringAfterDot.match(RegexValidators.ZEROES_AFTER_DOT_IN_DECIMAL);
            precision = match ? match[0].length : 0;
        }
    }
    return formatNumber(amount, precision);
};
//# sourceMappingURL=amount.js.map